import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Globe, ShieldCheck, ChevronDown } from 'lucide-react';
import { useTheme } from '../ThemeContext';

// Social icon SVGs (inline to avoid lucide version issues)
const LinkedinIcon = () => (<svg viewBox="0 0 24 24" className="w-3 h-3 fill-current"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>);
const InstagramIcon = () => (<svg viewBox="0 0 24 24" className="w-3 h-3 fill-none stroke-current" strokeWidth="1.5" strokeLinecap="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0" fill="currentColor" strokeWidth="2"/></svg>);
const YoutubeIcon = () => (<svg viewBox="0 0 24 24" className="w-3 h-3 fill-current"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75,15.02 15.5,12 9.75,8.98 9.75,15.02" /></svg>);

// const PRODUCTS_NAV = [
//   { label: 'Smart Lighting', to: '/products' },
//   { label: 'Climate Control', to: '/products' },
//   { label: 'Security Hub', to: '/products' },
//   { label: 'Smart Switches', to: '/products' },
// ];

const DOWNLOADS_NAV = [
  { label: 'Brochure 2026', to: '/downloads' },
  { label: 'Product Catalog', to: '/downloads' },
  { label: 'Technical Specs', to: '/downloads' },
];

const COMPANY_NAV = [
  { label: 'About Us', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Blog', to: '/blog' },
  { label: "FAQ's", to: '/faqs' },
  { label: 'Contact', to: '/contact' },
];

const SOCIAL = [
  { Icon: LinkedinIcon, href: '#', label: 'LinkedIn' },
  { Icon: InstagramIcon, href: '#', label: 'Instagram' },
  { Icon: YoutubeIcon, href: '#', label: 'YouTube' },
  { Icon: Globe, href: '#', label: 'Website' },
];

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'hi', name: 'हिंदी', flag: '🇮🇳' },
  { code: 'mr', name: 'मराठी', flag: '🇮🇳' },
  { code: 'gu', name: 'ગુજરાતી', flag: '🇮🇳' }
];

export default function Footer() {
  const { theme } = useTheme();
  const [modalData, setModalData] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  const handlePolicyClick = (e, type) => {
    e.preventDefault();
    if (type === 'Privacy Policy') {
      setModalData({
        title: 'Privacy Policy',
        content: 'User data collected (name, email, IP) is used exclusively for service improvement. Opt-out options are available at any time by contacting our support.'
      });
    } else {
      setModalData({
        title: 'Terms of Service',
        content: 'Legal usage of our products and services is required. No misuse of automation systems is allowed or tolerated under any circumstances.'
      });
    }
  };

  return (
    <footer className="bg-theme text-theme border-t border-theme transition-colors duration-1000">

      {/* ── Contact strip ─────────────────────────────────────── */}
      {/* <div className="py-12 md:py-16 px-4 sm:px-8 md:px-14 border-b border-theme transition-colors duration-1000">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <h2 className="font-serif font-light text-2xl md:text-3xl text-theme mb-1 transition-colors duration-1000">
              Ready to elevate
              <span className="block italic text-bronze-400"> your space?</span>
            </h2>
            <p className="text-xs text-theme-secondary mt-3 uppercase tracking-widest font-mono transition-colors duration-1000">Home & Industrial automation solutions across India.</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            className="flex flex-wrap gap-3"
          >
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-bronze-gradient text-black text-[10px] font-mono uppercase tracking-widest hover:shadow-gold-glow-sm transition-all duration-500 font-semibold"
            >
              Get in Touch
            </Link>
            <a
              href={`https://wa.me/918984684689?text=${encodeURIComponent("Hi IOTIQ! I'd like to know more about your solutions.")}`}
              target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#25D366]/30 text-[#25D366] text-[10px] font-mono uppercase tracking-widest hover:bg-[#25D366]/10 transition-all duration-500"
            >
              <svg viewBox="0 0 24 24" className="w-3 h-3 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </a>
          </motion.div>
        </div>
      </div> */}

      {/* ── Main footer ───────────────────────────────────────── */}
      <div className="py-12 md:py-16 px-4 sm:px-8 md:px-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12 mb-12">

          {/* Brand column */}
          <div className="sm:col-span-2 lg:col-span-1 space-y-6">
            <img
              src="/iotiq-logo.png"
              alt="IOTIQ Logo"
              className={`h-8 w-auto object-contain transition-all duration-700 ${theme === 'dark' ? 'brightness-0 invert' : ''}`}
            />
            <p className="text-xs text-theme-secondary leading-relaxed max-w-[36ch] font-light italic">
              Technology-driven smart automation for homes and industries — powered by 40+ years of engineering excellence.
            </p>
            <div className="flex items-center gap-2 text-[10px] text-theme-muted uppercase tracking-ultra">
              <ShieldCheck size={11} className="text-bronze-400" />
              <span>OEM Manufacturer · Hyderabad</span>
            </div>
            <div className="flex gap-3">
              {SOCIAL.map(({ Icon, href, label }) => (
                <a key={label} href={href} aria-label={label} className="group w-8 h-8 rounded-full border border-theme flex items-center justify-center hover:border-bronze-400/30 transition-colors duration-500">
                  <Icon size={12} className="text-theme-muted group-hover:text-bronze-400 transition-colors duration-500" />
                </a>
              ))}
            </div>
          </div>

          {/* Products nav */}
          {/* <div>
            <h4 className="text-[10px] uppercase tracking-widest text-bronze-400/70 mb-6 font-mono font-bold">Products</h4>
            <ul className="space-y-3.5">
              {PRODUCTS_NAV.map(link => (
                <li key={link.label}>
                  <Link to={link.to} className="text-xs uppercase tracking-widest text-theme-secondary hover:text-bronze transition-colors duration-400 font-mono">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Downloads nav */}
          <div>
            <h4 className="text-[10px] uppercase tracking-widest text-bronze-400/70 mb-6 font-mono font-bold">Downloads</h4>
            <ul className="space-y-3.5">
              {DOWNLOADS_NAV.map(link => (
                <li key={link.label}>
                  <Link to={link.to} className="text-xs uppercase tracking-widest text-theme-secondary hover:text-bronze transition-colors duration-400 font-mono">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company nav */}
          <div>
            <h4 className="text-[10px] uppercase tracking-widest text-bronze-400/70 mb-6 font-mono font-bold">Company</h4>
            <ul className="space-y-3.5">
              {COMPANY_NAV.map(link => (
                <li key={link.label}>
                  <Link to={link.to} className="text-xs uppercase tracking-widest text-theme-secondary hover:text-bronze transition-colors duration-400 font-mono">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-[10px] uppercase tracking-widest text-bronze-400/70 mb-6 font-mono font-bold">Contact</h4>
            <div className="space-y-4">
              <a href="tel:+918984684689" className="flex items-start gap-2.5 text-xs text-theme-secondary hover:text-bronze-400 transition-colors group">
                <span className="text-bronze-400 mt-0.5">✆</span>
                <span className="font-mono">+91 8984684689</span>
              </a>
              <a href="mailto:connect@iotiq.co.in" className="flex items-start gap-2.5 text-xs text-theme-secondary hover:text-bronze-400 transition-colors">
                <Mail size={12} className="text-bronze-400 mt-0.5 flex-shrink-0" />
                <span className="font-mono">connect@iotiq.co.in</span>
              </a>
              <div className="flex items-start gap-2.5 text-xs text-theme-muted">
                <MapPin size={12} className="text-bronze-400 mt-0.5 flex-shrink-0" />
                <span className="font-mono leading-relaxed">7th Floor, pardha's Picasa,<br />Kavuri Hills, Madhapur,<br />Hyderabad – 500033</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="h-px bg-gradient-to-r from-transparent via-bronze-500/15 to-transparent mb-8 max-w-6xl mx-auto" />
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-6 text-[10px] text-theme-muted uppercase tracking-ultra">
            <p>© 2026 IOTIQ A Group Company of ACS Technologies Ltd.</p>
            <div className="flex items-center gap-3">
              <button
                onClick={(e) => handlePolicyClick(e, 'Privacy Policy')}
                className="hover:text-gold transition-colors duration-300"
              >
                Privacy Policy
              </button>
              <span className="text-theme-muted/40">|</span>
              <button 
                onClick={(e) => handlePolicyClick(e, 'Terms of Service')}
                className="hover:text-gold transition-colors duration-300"
              >
                Terms of Service
              </button>
            </div>
          </div>
          <div className="flex items-center gap-6">
            {/* Languages Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
                className="flex items-center gap-2 text-[10px] text-theme-muted hover:text-gold transition-colors duration-300 uppercase tracking-ultra"
              >
                <Globe size={10} />
                <span>{LANGUAGES.find(lang => lang.code === selectedLanguage)?.flag}</span>
                <span>{LANGUAGES.find(lang => lang.code === selectedLanguage)?.name}</span>
                <ChevronDown size={8} className={`transition-transform duration-300 ${isLanguageDropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              <AnimatePresence>
                {isLanguageDropdownOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: -10, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -10, scale: 0.95 }}
                    transition={{ duration: 0.2 }}
                    className="absolute bottom-full right-0 mb-2 w-32 bg-theme/90 backdrop-blur-2xl border border-theme rounded-lg p-2 shadow-2xl z-50"
                  >
                    {LANGUAGES.map((language) => (
                      <button
                        key={language.code}
                        onClick={() => {
                          setSelectedLanguage(language.code);
                          setIsLanguageDropdownOpen(false);
                        }}
                        className="w-full flex items-center gap-2 px-3 py-2 text-[8px] text-theme-secondary hover:text-gold hover:bg-theme-secondary transition-colors duration-200 rounded uppercase tracking-ultra"
                      >
                        <span>{language.flag}</span>
                        <span>{language.name}</span>
                      </button>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className="flex items-center gap-6 text-[10px] text-theme-muted">
              <div className="flex items-center gap-2">
                <Mail size={10} />
                <span>connect@iotiq.co.in</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={10} />
                <span>Mumbai, India</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Policy Modal */}
      <AnimatePresence>
        {modalData && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[9999] flex items-center justify-center p-6 bg-theme/80 backdrop-blur-md"
            onClick={() => setModalData(null)}
          >
            <motion.div
              initial={{ scale: 0.95, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.95, y: 20 }}
              onClick={e => e.stopPropagation()}
              className="bg-theme border border-bronze-500/20 p-10 rounded-[2.5rem] max-w-lg w-full relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-radial-gradient from-bronze-500/5 to-transparent pointer-events-none" />
              <button 
                onClick={() => setModalData(null)}
                className="absolute top-8 right-8 text-theme-muted hover:text-bronze-400 transition-colors"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <h3 className="font-serif text-3xl italic text-theme mb-6">{modalData.title}</h3>
              <p className="text-xs text-theme-secondary uppercase tracking-widest leading-loose font-light">
                {modalData.content}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </footer>
  );
}
